import axios from '../../../api/axios.js'

// 获取默认收货地址
export const getDefaultAddress = (params) => {
    return axios.get(`merchant/api/members/addresses/default/${params.memberCode}`, {})
}

// 获取地址信息列表
export const getAddressList = (params) => {
    return axios.get(`merchant/api/members/addresses/${params.memberCode}`, {})
}

// 添加地址
export const saveAddress = (params) => {
    return axios.post('merchant/api/members/addresses', params)
}

// 编辑地址
export const editAddress = (params) => {
    return axios.put(`merchant/api/members/addresses/${params.addressId}`, params)
}

// 获取地址详情
export const addressDetail = (params) => {
    return axios.get(`merchant/api/members/addresses/detail/${params.addressId}`, {})
}

// 删除地址
export const delAddress = (params) => {
    return axios.delete(`merchant/api/members/addresses/${params.addressId}`, {})
}

// 仓库地址
export const depotAddress = (params) => {
    return axios.get('merchant/api/warehouses/app', { params })
}
